import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    key: 1,
    class: "nav-item dropdown"
};
const _hoisted_2 = ["id"];
const _hoisted_3 = ["aria-labelledby"];
const _hoisted_4 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_MenuActionLink = _resolveComponent("MenuActionLink");
    const _component_MenuLevel2 = _resolveComponent("MenuLevel2");
    return (_ctx.isAction(_ctx.menuData))
        ? (_openBlock(), _createBlock(_component_MenuActionLink, {
            key: 0,
            isTopLevel: true,
            menuData: _ctx.menuData
        }, null, 8, ["menuData"]))
        : (_openBlock(), _createElementBlock("li", _hoisted_1, [
            _createElementVNode("a", {
                class: "nav-link top-level-menu-item",
                "data-bs-auto-close": "outside",
                id: 'menu1-' + _ctx.idSlug,
                role: "button",
                "data-bs-toggle": "dropdown",
                "aria-expanded": "false"
            }, _toDisplayString(_ctx.menuData.text), 9, _hoisted_2),
            _createElementVNode("ul", {
                class: "dropdown-menu",
                "aria-labelledby": 'menu1-' + _ctx.idSlug,
                style: { "min-width": "180px" }
            }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItemsWithSeparators, (item, idx) => {
                    return (_openBlock(), _createElementBlock("span", { key: idx }, [
                        (_ctx.isSeparator(item))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_4, [...(_cache[0] || (_cache[0] = [
                                    _createElementVNode("hr", { class: "dropdown-divider" }, null, -1)
                                ]))]))
                            : (_openBlock(), _createBlock(_component_MenuLevel2, {
                                key: 1,
                                menuData: item
                            }, null, 8, ["menuData"]))
                    ]));
                }), 128))
            ], 8, _hoisted_3)
        ]));
}
